import { FC, ReactElement, ReactNode } from "react";
import { Link } from "react-router-dom";

import { ClassName } from "config/types";

import { ConditionalWrapper } from "./ConditionalWrapper";

interface IProps {
  condition: boolean;
  to: string;
  className?: ClassName;
  children?: ReactNode;
}

export const ConditionalLink: FC<IProps> = ({
  children,
  condition,
  to,
  className,
  ...props
}): ReactElement => {
  return (
    <ConditionalWrapper condition={condition} props={{ to, className, ...props }} wrapper={Link}>
      {children}
    </ConditionalWrapper>
  );
};
